module.exports = __webpack_public_path__ + "img/nwsl2austin.2235c1bb.png";